// extracted by mini-css-extract-plugin
export default {"noItemCollection":"NoItemCollection_noItemCollection__buJmI"};